import { useEffect } from "react";
import { useCodelist } from "../../hooks/useCodelist";
import { codelistUtils } from "../../utils/codelistUtils";
import DynamicForm from "./DynamicForm";

const AuditDeleteReason = (props: any) => {
  const { errors, register, control } = props;

  const { getCodelistData, codelistData } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: ["EDIT_REASON"] } });
  }, []);

  return (
    <DynamicForm
      fieldsJson={[
        {
          name: "delete_reason",
          label: "Select your reason*",
          size: 12,
          inputType: "autocomplete",
          options: codelistUtils(codelistData, "EDIT_REASON")
            ?.codelistCodeValues,
        },
        {
          name: "delete_comment",
          label: "Add your comment*",
          size: 12,
        },
      ]}
      errors={errors}
      register={register}
      control={control}
    />
  );
};

export default AuditDeleteReason;
